import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { Control, Controller, FieldErrors } from "react-hook-form";

import AllLocationsFilterDropdownContainer from "../../../../../../../../common/components/locations/AllLocationsFilterDropdownContainer";
import { AutocompleteOptionType } from "../../../../../../../../common/models/autocomplete";
import { IAlertForm } from "../CreateAlertContainer";

interface ILocationAlertFormProps {
  formValues: IAlertForm;
  control: Control<IAlertForm>;
  errors: FieldErrors<IAlertForm>;
  onLocationChange: (location: AutocompleteOptionType) => void;
  onLocationTagChange: (tagId: string) => void;
}

const LocationAlertForm = ({
  formValues,
  control,
  errors,
  onLocationChange,
  onLocationTagChange,
}: ILocationAlertFormProps) => {
  const tagId = formValues.tagId;
  const isModelEntity = formValues.entity === "Model";
  const hasLocationError = !isModelEntity && !!errors.locationId;

  let controllerName: "locationId" | "tagId" = "locationId";

  if (tagId) {
    controllerName = "tagId";
  }

  return (
    <Controller
      name={controllerName}
      control={control}
      rules={{
        // When selecting Model entity, location/tag can be empty
        required: isModelEntity ? false : "This field is required",
      }}
      render={({ field }) => (
        <FormControl
          error={hasLocationError}
          sx={{
            width: "100%",
          }}
        >
          <AllLocationsFilterDropdownContainer
            {...field}
            setLocation={onLocationChange}
            setTagId={onLocationTagChange}
            size="medium"
            hasError={hasLocationError}
            ignoreDefaultValue
          />
          {!isModelEntity && errors.locationId && (
            <FormHelperText error>{errors.locationId.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default LocationAlertForm;
